import { render, staticRenderFns } from "./DashboardFixed.vue?vue&type=template&id=6b1f88ab&lang=pug&"
import script from "./DashboardFixed.vue?vue&type=script&lang=js&"
export * from "./DashboardFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports